// extracted by mini-css-extract-plugin
module.exports = {"root":"product-cards-module__root___31XEd","title":"product-cards-module__title___2D7u1","content":"product-cards-module__content___2_ohC"};